var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkLibrary64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 3,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.502 26.911a10.33 10.33 0 013.478 3.821c.992 1.858 1.52 3.983 1.52 7.369v.198c0 3.386-.528 5.511-1.52 7.369a10.35 10.35 0 01-4.301 4.31c-1.855.993-3.976 1.522-7.356 1.522H32.849c-3.38 0-5.5-.53-7.355-1.523a10.35 10.35 0 01-4.302-4.309c-.991-1.858-1.52-3.983-1.52-7.369v-.198c0-3.386.529-5.511 1.52-7.369a10.35 10.35 0 014.302-4.31c1.854-.993 3.976-1.522 7.355-1.522h.965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.498 37.089a10.33 10.33 0 01-3.478-3.821c-.992-1.858-1.52-3.983-1.52-7.369v-.198c0-3.386.528-5.511 1.52-7.369a10.35 10.35 0 014.301-4.31c1.855-.993 3.976-1.522 7.356-1.522h13.474c3.38 0 5.5.53 7.355 1.523a10.35 10.35 0 014.302 4.309c.991 1.858 1.52 3.983 1.52 7.369v.198c0 3.386-.529 5.511-1.52 7.369a10.35 10.35 0 01-4.302 4.31c-1.854.993-3.976 1.522-7.355 1.522h-.965"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkLibrary64);
export default __webpack_public_path__ + "static/media/link-library-64.7376a3b6.svg";
export { ForwardRef as ReactComponent };